import type { ServiceCard } from '@/types';

export const services: ServiceCard[] = [
  {
    id: 'control-calidad',
    title: 'Control de Calidad',
    description: 'Garantiza la calidad de tu proyecto con pruebas certificadas y precisión avanzada.',
    image: '/services_cards/01_Control_Calidad.jpg',
    link: '/servicios/control-de-calidad',
    contentPosition: 'bottom',
  },
  {
    id: 'mecanica-suelos',
    title: 'Mecánica de Suelos',
    description: 'Estudiamos las propiedades y el comportamiento de los suelos para asegurar su adecuada utilización en la construcción, garantizando estabilidad y durabilidad.',
    image: '/services_cards/02_Mecánica_Suelos.jpg',
    link: '/servicios/mecanica-de-suelos',
    contentPosition: 'bottom',
  },
  {
    id: 'ingenieria-estructural',
    title: 'Ingeniería Estructural',
    description: 'Fomentamos sistemas y materiales innovadores que mejoran la eficiencia y calidad en la construcción.',
    image: '/services_cards/03_Estructuras.jpg',
    link: '/servicios/ingenieria-estructural',
    contentPosition: 'bottom',
  },
  {
    id: 'topografia',
    title: 'Topografía',
    description: 'Aseguramos el cumplimiento de plazos y estándares de calidad mediante una supervisión integral que impulsa el éxito de cada etapa sin afectar su desarrollo.',
    image: '/services_cards/06_Topografia.jpg',
    link: '/servicios/topografia',
    contentPosition: 'bottom',
  },
  {
    id: 'supervision-obra',
    title: 'Supervisión de Obra',
    description: 'Aseguramos el cumplimiento de plazos y estándares de calidad mediante una supervisión integral que impulsa el éxito de cada etapa sin afectar su desarrollo.',
    image: '/services_cards/05_SupervisioO.jpg',
    link: '/servicios/supervision-de-obra',
    contentPosition: 'bottom',
  },

  
  {
    id: 'arquitectura',
    title: 'Arquitectura',
    description: 'Aseguramos el cumplimiento de plazos y estándares de calidad mediante una supervisión integral que impulsa el éxito de cada etapa sin afectar su desarrollo.',
    image: '/services_cards/Arquitectura.jpg',
    link: '/servicios/arquitectura',
    contentPosition: 'bottom',
  },
   
];
